<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>App Popup</h5>
                <div>
                    <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
                    <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious"
                        icon="pi pi-chevron-left" />
                    <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm"
                        iconPos="right" />
                </div>
            </div>
            <div class="card">
                <div>
                    <span class="subtext p-mt-2 p-text-capitalize">
                        <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : '-' }} </h6>
                    </span>
                </div>
                <Toolbar >
                    <template v-slot:left>
                        <Button icon="pi pi-android" label="Android" text raised
                            :class="myAssignedAndTeamTicketStatus == 2 ? 'p-mr-2 p-button' : 'p-mr-2 p-button-outlined'"
                            @click="getAndroidDynamicContentInfo()" />
                        <Button icon="pi pi-apple" label="iOS" text raised
                            :class="myAssignedAndTeamTicketStatus == 1 ? 'p-mr-2 p-button' : 'p-mr-2 p-button-outlined'"
                            @click="getiSODynamicContentInfo()" />
                            <Button icon="pi pi-globe" label="Web" text raised
                            :class="myAssignedAndTeamTicketStatus == 3 ? 'p-mr-2 p-button' : 'p-mr-2 p-button-outlined'"
                            @click="getWebDynamicContentInfo()" />
                    </template>
                </Toolbar>
                <div class="p-py-4 p-px-3" v-if="myAssignedAndTeamTicketStatus == 1">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-4 p-md-4">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <div>
                                    <label>Is the App Popup Currently Active?</label>
                                </div>
                                <div class="p-field-radiobutton p-mb-0"> <span class="p-mr-3">OFF</span>
                                    <InputSwitch :disabled="disableInputBool || editaboutformloader"
                                        v-model="ios.isActive" /> <span class="p-ml-3">ON</span>
                                </div>
                            </div>
                        </div>
                        <Divider type="dashed" v-if="ios.isActive" />
                        <div class="p-field p-col-4 p-md-4" v-if="ios.isActive">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <div>
                                    <label>App Popup Close button?</label>
                                </div>
                                <div class="p-field-radiobutton p-mb-0"> <span class="p-mr-3">OFF</span>
                                    <InputSwitch :disabled="disableInputBool || editaboutformloader"
                                        v-model="ios.closeButton" /> <span class="p-ml-3">ON</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Divider type="dashed" v-if="ios.isActive" />
                    <div class="p-fluid p-formgrid p-grid" v-if="ios.isActive">
                        <div class="p-field p-col-12 p-md-12">
                            <label for="andtitle"> Popup Title <span class="p-invalid p-error">*</span>
                            </label>
                            <InputText id="andtitle" :disabled="disableInputBool || editaboutformloader"
                                v-model.trim="ios.title" required="true" autofocus
                                :class="{ 'p-invalid': submitted && !ios.title }" />
                            <small class="p-invalid p-error" v-if="v$.ios.title.$error">{{
                                v$.ios.title.$errors[0].$message
                            }}</small>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <label for="anddescription">
                                Popup Content
                                <span class="p-invalid p-error">*</span>
                            </label>
                            <Textarea id="anddescription" class="p-text-capitalize" v-model="ios.description"
                                :autoResize="true" rows="4" :disabled="disableInputBool || editaboutformloader"
                                cols="30" required="true" :class="{ 'p-invalid': submitted && !ios.description }"
                                maxlength="250" />
                            <small class="p-invalid p-error" v-if="v$.ios.description.$error">{{
                                v$.ios.description.$errors[0].$message
                            }}</small>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-4">
                                    <label for="image">
                                        Upload Popup Image
                                    </label>
                                    <FileUpload mode="basic" :disabled="disableInputBool || editaboutformloader"
                                        ref="aboutseditscreenref" accept="image/*" v-model="ios.aboutcontentimg"
                                        chooseLabel="Upload File" :auto="true"
                                        @select="handleDynamicContentImage($event, 'ios')" />
                                    <small class="p-invalid p-error" v-if="errorscreenimgedit">{{ errorscreenimgedit
                                    }}</small>
                                    <!-- <div>
                                        <img v-if="clientlogoUrl && clientlogoUrl.url" class="p-pt-2"
                                            role="presentation" :alt="clientlogoUrl.name" :src="clientlogoUrl.url"
                                            width="120" height="120" />
                                    </div> -->
                                </div>
                                <div class="p-field p-col-12 p-md-8">
                                    <div v-if="ios.editpreviewurl">
                                        <img :src="ios.editpreviewurl" alt="Image" width="140" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <div>
                                    <label>Add Popup Button</label>
                                </div>
                                <div class="p-field-radiobutton p-mb-0">
                                    <InputSwitch v-model="ios.isButton" />
                                </div>
                            </div>
                        </div>
                        <div class="p-field p-col-6 p-md-6" v-if="ios.isButton">
                            <label for="andtitle">Name
                            </label>
                            <InputText id="andtitle" :disabled="disableInputBool || editaboutformloader"
                                v-model.trim="ios.name" required="false" autofocus />
                        </div>
                        <div class="p-field p-col-6 p-md-6" v-if="ios.isButton">
                            <label for="andtitle">URL
                            </label>
                            <InputText id="andtitle" :disabled="disableInputBool || editaboutformloader"
                                v-model.trim="ios.url" required="false" autofocus />
                        </div>
                    </div>
                    <div class="p-d-flex p-pt-4">
                        <Button v-if="!editaboutformloader" :disabled="editaboutformloader" label="Submit"
                            icon="pi pi-check" class="p-button-text p-ml-auto" @click="updateiOSDetailUpdatebtn"
                            style="width: 90px"></Button>
                        <Button v-show="editaboutformloader" icon="pi pi-spin pi-spinner indigo-color"
                            class="p-button-text p-ml-auto" style="width: 90px"></Button>
                    </div>
                </div>
                <div class="p-py-4 p-px-3" v-if="myAssignedAndTeamTicketStatus == 2">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-4 p-md-4">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <div>
                                    <label>Is the App Popup Currently Active?</label>
                                </div>
                                <div class="p-field-radiobutton p-mb-0"> <span class="p-mr-3">OFF</span>
                                    <InputSwitch :disabled="disableInputBool || editaboutformloader"
                                        v-model="android.isActive" /> <span class="p-ml-3">ON</span>
                                </div>
                            </div>
                        </div>
                        <Divider type="dashed" v-if="android.isActive" />
                        <div class="p-field p-col-4 p-md-4"  v-if="android.isActive">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <div>
                                    <label>App Popup Close button?</label>
                                </div>
                                <div class="p-field-radiobutton p-mb-0"> <span class="p-mr-3">OFF</span>
                                    <InputSwitch :disabled="disableInputBool || editaboutformloader"
                                        v-model="android.closeButton" /> <span class="p-ml-3">ON</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Divider type="dashed" v-if="android.isActive" />
                    <div class="p-fluid p-formgrid p-grid" v-if="android.isActive">
                        <div class="p-field p-col-12 p-md-12">
                            <label for="andtitle"> Popup Title <span class="p-invalid p-error">*</span>
                            </label>
                            <InputText id="andtitle" :disabled="disableInputBool || editaboutformloader"
                                v-model.trim="android.title" required="true" autofocus
                                :class="{ 'p-invalid': submitted && !android.title }" />
                            <small class="p-invalid p-error" v-if="v$.android.title.$error">{{
                                v$.android.title.$errors[0].$message
                            }}</small>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <label for="anddescription">
                                Popup Content
                                <span class="p-invalid p-error">*</span>
                            </label>
                            <Textarea id="anddescription" class="p-text-capitalize" v-model="android.description"
                                :autoResize="true" rows="4" :disabled="disableInputBool || editaboutformloader"
                                cols="30" required="true" :class="{ 'p-invalid': submitted && !android.description }"
                                maxlength="250" />
                            <small class="p-invalid p-error" v-if="v$.android.description.$error">{{
                                v$.android.description.$errors[0].$message
                            }}</small>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-4">
                                    <label for="image">
                                        Upload Popup Image
                                    </label>
                                    <FileUpload mode="basic" :disabled="disableInputBool || editaboutformloader"
                                        ref="aboutseditscreenref" accept="image/*" v-model="android.aboutcontentimg"
                                        chooseLabel="Upload File" :auto="true"
                                        @select="handleDynamicContentImage($event, 'android')" />
                                    <small class="p-invalid p-error" v-if="errorscreenimgedit">{{ errorscreenimgedit
                                    }}</small>
                                    <!-- <div>
                                        <img v-if="clientlogoUrl && clientlogoUrl.url" class="p-pt-2"
                                            role="presentation" :alt="clientlogoUrl.name" :src="clientlogoUrl.url"
                                            width="120" height="120" />
                                    </div> -->
                                </div>
                                <div class="p-field p-col-12 p-md-8">
                                    <div v-if="android.editpreviewurl">
                                        <img :src="android.editpreviewurl" alt="Image" width="140" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <div>
                                    <label>Add Popup Button</label>
                                </div>
                                <div class="p-field-radiobutton p-mb-0">
                                    <InputSwitch v-model="android.isButton" />
                                </div>
                            </div>
                        </div>
                        <div class="p-field p-col-6 p-md-6" v-if="android.isButton">
                            <label for="andtitle">Name
                            </label>
                            <InputText id="andtitle" :disabled="disableInputBool || editaboutformloader"
                                v-model.trim="android.name" required="false" autofocus />
                        </div>
                        <div class="p-field p-col-6 p-md-6" v-if="android.isButton">
                            <label for="andtitle">URL
                            </label>
                            <InputText id="andtitle" :disabled="disableInputBool || editaboutformloader"
                                v-model.trim="android.url" required="false" autofocus />
                        </div>
                    </div>
                    <div class="p-d-flex p-pt-4">
                        <Button v-if="!editaboutformloader" :disabled="editaboutformloader" label="Submit"
                            icon="pi pi-check" class="p-button-text p-ml-auto" @click="updateAndroidDetailUpdatebtn"
                            style="width: 90px"></Button>
                        <Button v-show="editaboutformloader" icon="pi pi-spin pi-spinner indigo-color"
                            class="p-button-text p-ml-auto" style="width: 90px"></Button>
                    </div>
                </div>
                <div class="p-py-4 p-px-3" v-if="myAssignedAndTeamTicketStatus == 3">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-4 p-md-4">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <div>
                                    <label>Is the App Popup Currently Active?</label>
                                </div>
                                <div class="p-field-radiobutton p-mb-0"><span class="p-mr-3">OFF</span>
                                    <InputSwitch :disabled="disableInputBool || editaboutformloader"
                                        v-model="web.isActive" /> <span class="p-ml-3">ON</span>
                                </div>
                            </div>
                        </div>
                        <Divider type="dashed" v-if="web.isActive" />
                        <div class="p-field p-col-4 p-md-4" v-if="web.isActive">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <div>
                                    <label>Web Popup Close button?</label>
                                </div>
                                <div class="p-field-radiobutton p-mb-0"><span class="p-mr-3">OFF</span>
                                    <InputSwitch :disabled="disableInputBool || editaboutformloader"
                                        v-model="web.closeButton" /> <span class="p-ml-3">ON</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Divider type="dashed" v-if="web.isActive" />
                    <div class="p-fluid p-formgrid p-grid" v-if="web.isActive">
                        <div class="p-field p-col-12 p-md-12">
                            <label for="andtitle"> Popup Title <span class="p-invalid p-error">*</span>
                            </label>
                            <InputText id="andtitle" :disabled="disableInputBool || editaboutformloader"
                                v-model.trim="web.title" required="true" autofocus
                                :class="{ 'p-invalid': submitted && !web.title }" />
                            <small class="p-invalid p-error" v-if="v$.web.title.$error">{{
                                v$.web.title.$errors[0].$message
                            }}</small>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <label for="anddescription">
                                Popup Content
                                <span class="p-invalid p-error">*</span>
                            </label>
                            <Textarea id="anddescription" class="p-text-capitalize" v-model="web.description"
                                :autoResize="true" rows="4" :disabled="disableInputBool || editaboutformloader"
                                cols="30" required="true" :class="{ 'p-invalid': submitted && !web.description }"
                                maxlength="250" />
                            <small class="p-invalid p-error" v-if="v$.web.description.$error">{{
                                v$.web.description.$errors[0].$message
                            }}</small>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-4">
                                    <label for="image">
                                        Upload Popup Image
                                    </label>
                                    <FileUpload mode="basic" :disabled="disableInputBool || editaboutformloader"
                                        ref="aboutseditscreenref" accept="image/*" v-model="web.aboutcontentimg"
                                        chooseLabel="Upload File" :auto="true"
                                        @select="handleDynamicContentImage($event, 'web')" />
                                    <small class="p-invalid p-error" v-if="errorscreenimgedit">{{ errorscreenimgedit
                                    }}</small>
                                    <!-- <div>
                                        <img v-if="clientlogoUrl && clientlogoUrl.url" class="p-pt-2"
                                            role="presentation" :alt="clientlogoUrl.name" :src="clientlogoUrl.url"
                                            width="120" height="120" />
                                    </div> -->
                                </div>
                                <div class="p-field p-col-12 p-md-8">
                                    <div v-if="web.editpreviewurl">
                                        <img :src="web.editpreviewurl" alt="Image" width="140" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <div>
                                    <label>Add Popup Button</label>
                                </div>
                                <div class="p-field-radiobutton p-mb-0">
                                    <InputSwitch v-model="web.isButton" />
                                </div>
                            </div>
                        </div>
                        <div class="p-field p-col-6 p-md-6" v-if="web.isButton">
                            <label for="andtitle">Name
                            </label>
                            <InputText id="andtitle" :disabled="disableInputBool || editaboutformloader"
                                v-model.trim="web.name" required="false" autofocus />
                        </div>
                        <div class="p-field p-col-6 p-md-6" v-if="web.isButton">
                            <label for="andtitle">URL
                            </label>
                            <InputText id="andtitle" :disabled="disableInputBool || editaboutformloader"
                                v-model.trim="web.url" required="false" autofocus />
                        </div>
                    </div>
                    <div class="p-d-flex p-pt-4">
                        <Button v-if="!editaboutformloader" :disabled="editaboutformloader" label="Submit"
                            icon="pi pi-check" class="p-button-text p-ml-auto" @click="updateWebDetailUpdatebtn"
                            style="width: 90px"></Button>
                        <Button v-show="editaboutformloader" icon="pi pi-spin pi-spinner indigo-color"
                            class="p-button-text p-ml-auto" style="width: 90px"></Button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useRoute } from 'vue-router';
import router from '@/router';
import { required, helpers } from '@vuelidate/validators';

export default {
    data() {
        return {
            v$: useValidate(),
            android: {
                title: "",
                description: "",
                isActive: true,
                isButton: true,
                name: '',
                aboutcontentimg: '',
                url: '',
                editpreviewurl: '',
                existAboutsId: '',
                closeButton: false,
            },
            ios: {
                title: "",
                description: "",
                isActive: true,
                isButton: true,
                name: '',
                aboutcontentimg: '',
                url: '',
                editpreviewurl: '',
                existAboutsId: '',
                closeButton: false,
            },
            web: {
                title: "",
                description: "",
                isActive: true,
                isButton: true,
                name: '',
                aboutcontentimg: '',
                url: '',
                editpreviewurl: '',
                existAboutsId: '',
                closeButton: false,
            },
            localstorageimgpath: '',
            userProfileImage: '',
            profileupload: {
                uploadavtimg: null,
            },
            errorscreenimgedit: '',
            editscreencount: 0,
            screenfileedit: null,
            // editpreviewurl: null,
            editaboutformloader: false,
            disableBtnBool: false,
            disableInputBool: false,
            showprofiledetails: true,
            getDataLoader: false,
            localAdminName: '',
            routeParam: '',
            myAssignedAndTeamTicketStatus: 2,
        };
    },
    validations() {
        return {
            android: {
                title: {
                    required: helpers.withMessage("Please enter title", required),
                },
                description: {
                    required: helpers.withMessage("Please enter description", required),
                },
            },
            ios: {
                title: {
                    required: helpers.withMessage("Please enter title", required),
                },
                description: {
                    required: helpers.withMessage("Please enter description", required),
                },
            },
            web: {
                title: {
                    required: helpers.withMessage("Please enter title", required),
                },
                description: {
                    required: helpers.withMessage("Please enter description", required),
                },
            },
        };
    },
    ApiService: null,
    interval: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        const route = useRoute();
        this.routeParam = route.params.adminSubId;
        this.localAdminName = localStorage.localAdminName;
        this.loading = true;
        this.getAndroidDynamicContentInfo();
    },
    methods: {
        getAndroidDynamicContentInfo() {
            this.myAssignedAndTeamTicketStatus = 2;
            this.activate_read_key_arr = [];
            this.android.description = '';
            this.android.title = '';
            this.android.editpreviewurl = '';
            this.android.url = '';
            this.android.isActive = false;
            this.android.isButton = false;
            this.ApiService.getPopUp({ mci7: 1, maa1: this.routeParam }).then((items) => {
                if (items.success == true) {
                    this.aboutsDetailsList = items.data;
                    if (this.aboutsDetailsList.mci7 == 1) {
                        this.android.existAboutsId = this.aboutsDetailsList.mci1;
                        this.android.title = this.aboutsDetailsList.mci2;
                        this.android.description = this.aboutsDetailsList.mci3;
                        this.android.isActive = this.aboutsDetailsList.mci4 == 1 ? true : false;
                        this.android.isButton = this.aboutsDetailsList.mci8 == 1 ? true : false;
                        this.android.name = this.aboutsDetailsList.mci9;
                        this.android.url = this.aboutsDetailsList.mci10;
                        this.android.editpreviewurl = this.aboutsDetailsList.mci6 ? this.aboutsDetailsList.mci6 : null;
                        this.android.closeButton = this.aboutsDetailsList.mci5 == 1 ? true : false;
                    }
                } else {
                    this.aboutsDetailsList = items.data;
                    this.android.existAboutsId = null
                    this.android.title = '';
                    this.android.description = '';
                }
                this.getDataLoader = false
            }).catch(($error) => {
                console.log("error", $error)
            })
        },
        getiSODynamicContentInfo() {
            this.myAssignedAndTeamTicketStatus = 1;
            this.activate_read_key_arr = [];
            // this.getDataLoader = true
            this.ApiService.getPopUp({ mci7: 2, maa1: this.routeParam }).then((items) => {
                if (items.success == true) {
                    this.aboutsDetailsList = items.data;
                    this.ios.existAboutsId = this.aboutsDetailsList.mci1;
                    this.ios.title = this.aboutsDetailsList.mci2;
                    this.ios.description = this.aboutsDetailsList.mci3;
                    this.ios.isActive = this.aboutsDetailsList.mci4 == 1 ? true : false;
                    this.ios.isButton = this.aboutsDetailsList.mci8 == 1 ? true : false;
                    this.ios.name = this.aboutsDetailsList.mci9;
                    this.ios.url = this.aboutsDetailsList.mci10;
                    this.ios.editpreviewurl = this.aboutsDetailsList.mci6 ? this.aboutsDetailsList.mci6 : null;
                    this.ios.closeButton = this.aboutsDetailsList.mci5 == 1 ? true : false;
                } else {
                    this.aboutsDetailsList = items.data;
                    this.ios.existAboutsId = null
                    this.android.title = '';
                    this.android.description = '';
                }
                this.getDataLoader = false
            }).catch(($error) => {
                console.log("error", $error)
            })
        },
        getWebDynamicContentInfo() {
            this.myAssignedAndTeamTicketStatus = 3;
            this.activate_read_key_arr = [];
            // this.getDataLoader = true
            this.ApiService.getPopUp({ mci7: 3, maa1: this.routeParam }).then((items) => {
                if (items.success == true) {
                    this.aboutsDetailsList = items.data;
                    this.web.existAboutsId = this.aboutsDetailsList.mci1;
                    this.web.title = this.aboutsDetailsList.mci2;
                    this.web.description = this.aboutsDetailsList.mci3;
                    this.web.isActive = this.aboutsDetailsList.mci4 == 1 ? true : false;
                    this.web.isButton = this.aboutsDetailsList.mci8 == 1 ? true : false;
                    this.web.name = this.aboutsDetailsList.mci9;
                    this.web.url = this.aboutsDetailsList.mci10;
                    this.web.editpreviewurl = this.aboutsDetailsList.mci6 ? this.aboutsDetailsList.mci6 : null;
                    this.web.closeButton = this.aboutsDetailsList.mci5 == 1 ? true : false;
                } else {
                    this.aboutsDetailsList = items.data;
                    this.web.existAboutsId = null
                    this.android.title = '';
                    this.android.description = '';
                }
                this.getDataLoader = false
            }).catch(($error) => {
                console.log("error", $error)
            })
        },
        handleDynamicContentImage(e, platform) {
            var file = e.files[0];
            let allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!file.size > 2048) {
                this.errorscreenimgedit = 'File size cannot exceed more than 2MB';
            } else if (!file.name.match(allowedExtensions)) {
                this.errorscreenimgedit = 'Invalid file type';
            } else {
                this.errorscreenimgedit = '';
                this.screenfileedit = null;
                this.android.editpreviewurl = null;
                this.ios.editpreviewurl = null;
                this.screenfileedit = file;
                if (platform == 'android') {
                    this.android.editpreviewurl = URL.createObjectURL(this.screenfileedit);
                } else if (platform == 'ios') {
                    this.ios.editpreviewurl = URL.createObjectURL(this.screenfileedit);
                } else if (platform == 'web') {
                    this.web.editpreviewurl = URL.createObjectURL(this.screenfileedit);
                }
            }
        },
        updateAndroidDetailUpdatebtn() {
            this.v$.android.$validate();
            var formData = new FormData();
            if (this.android.existAboutsId) {
                formData.append("mci1", this.android.existAboutsId);
            }
            formData.append("maa1", this.routeParam);
            formData.append("mci2", this.android.title);
            if (this.android.description) {
                formData.append("mci3", this.android.description);
            }
            if (this.screenfileedit != '' && this.screenfileedit != null) {
                formData.append('mci6', this.screenfileedit);
            }
            formData.append('mci4', this.android.isActive ? 1 : 0);
            formData.append('mci7', 1);
            formData.append('mci8', this.android.isButton ? 1 : 0);
            formData.append('mci5', this.android.closeButton ? 1 : 0);
            if (this.android.isButton) {
                formData.append('mci9', this.android.name);
                formData.append('mci10', this.android.url);
            }
            if (!this.v$.android.$error && this.errorscreenimgedit == '') {
                this.editaboutformloader = true;
                this.disableBtnBool = true;
                this.ApiService.addOrUpdatePopUp(formData).then((data) => {
                    if (data.status == 200) {
                        this.editaboutformloader = false;
                        var successMsg = data.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        setTimeout(() => {
                            this.v$.$reset();
                        }, 0);
                        this.editaboutsdetailstatus = false;
                        this.android.existAboutsId = "";
                        this.android.title = "";
                        this.android.description = "";
                        this.screenfileedit = null;
                        this.android.editpreviewurl = null;
                        this.editscreencount = '';
                        this.errorscreenimgedit = '';
                        this.showprofiledetails = true;
                        this.getAndroidDynamicContentInfo();
                    } else {
                        var errorMsg = data.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                        this.editaboutformloader = false;
                    }
                }).catch(($error) => {
                    console.log("error", $error)
                })
            } else {
                this.$error;
            }
        },
        updateiOSDetailUpdatebtn() {
            this.v$.ios.$validate();
            var formData = new FormData();
            if (this.ios.existAboutsId) {
                formData.append("mci1", this.ios.existAboutsId);
            }
            formData.append("maa1", this.routeParam);
            formData.append("mci2", this.ios.title);
            if (this.ios.description) {
                formData.append("mci3", this.ios.description);
            }
            if (this.screenfileedit != '' && this.screenfileedit != null) {
                formData.append('mci6', this.screenfileedit);
            }
            formData.append('mci4', this.ios.isActive ? 1 : 0);
            formData.append('mci7', 2);
            formData.append('mci8', this.ios.isButton ? 1 : 0);
            formData.append('mci5', this.ios.closeButton ? 1 : 0);
            if (this.ios.isButton) {
                formData.append('mci9', this.ios.name);
                formData.append('mci10', this.ios.url);
            }

            if (!this.v$.ios.$error && this.errorscreenimgedit == '') {
                this.editaboutformloader = true;
                this.disableBtnBool = true;
                this.ApiService.addOrUpdatePopUp(formData).then((data) => {
                    if (data.status == 200) {
                        this.editaboutformloader = false;
                        var successMsg = data.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        setTimeout(() => {
                            this.v$.$reset();
                        }, 0);
                        this.editaboutsdetailstatus = false;
                        this.ios.existAboutsId = "";
                        this.ios.title = "";
                        this.ios.description = "";
                        this.screenfileedit = null;
                        this.ios.editpreviewurl = null;
                        this.editscreencount = '';
                        this.errorscreenimgedit = '';
                        this.showprofiledetails = true;
                        this.getiSODynamicContentInfo();
                    } else {
                        var errorMsg = data.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                        this.editaboutformloader = false;
                    }
                }).catch(($error) => {
                    console.log("error", $error)
                })
            } else {
                this.$error;
            }
        },
        updateWebDetailUpdatebtn() {
            this.v$.web.$validate();
            var formData = new FormData();
            if (this.web.existAboutsId) {
                formData.append("mci1", this.web.existAboutsId);
            }
            formData.append("maa1", this.routeParam);
            formData.append("mci2", this.web.title);
            if (this.web.description) {
                formData.append("mci3", this.web.description);
            }
            if (this.screenfileedit != '' && this.screenfileedit != null) {
                formData.append('mci6', this.screenfileedit);
            }
            formData.append('mci4', this.web.isActive ? 1 : 0);
            formData.append('mci7', 3);
            formData.append('mci8', this.web.isButton ? 1 : 0);
            formData.append('mci5', this.web.closeButton ? 1 : 0);
            if (this.web.isButton) {
                formData.append('mci9', this.web.name);
                formData.append('mci10', this.web.url);
            }

            if (!this.v$.web.$error && this.errorscreenimgedit == '') {
                this.editaboutformloader = true;
                this.disableBtnBool = true;
                this.ApiService.addOrUpdatePopUp(formData).then((data) => {
                    if (data.status == 200) {
                        this.editaboutformloader = false;
                        var successMsg = data.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        setTimeout(() => {
                            this.v$.$reset();
                        }, 0);
                        this.editaboutsdetailstatus = false;
                        this.web.existAboutsId = "";
                        this.web.title = "";
                        this.web.description = "";
                        this.screenfileedit = null;
                        this.web.editpreviewurl = null;
                        this.editscreencount = '';
                        this.errorscreenimgedit = '';
                        this.showprofiledetails = true;
                        this.getWebDynamicContentInfo();
                    } else {
                        var errorMsg = data.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                        this.editaboutformloader = false;
                    }
                }).catch(($error) => {
                    console.log("error", $error)
                })
            } else {
                this.$error;
            }
        },


        goToDashboard() {
            router.push({
                name: "admindashboard",
                params: { adminId: this.routeParam },
            });
        },
        goToPrevious() {
            router.push({
                name: "paymentgatewaydetails",
                params: { adminSubId: this.routeParam },
            });
        },
        goToNext() {
            router.push({
                name: "AppUsersList",
                params: { adminSubId: this.routeParam },
            });
        }
    }

};
</script>

<style scoped></style>
